import { render, staticRenderFns } from "./LayoutBottomComponent.vue?vue&type=template&id=5ca81ffa&scoped=true&"
import script from "./LayoutBottomComponent.vue?vue&type=script&lang=js&"
export * from "./LayoutBottomComponent.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBottomComponent.vue?vue&type=style&index=0&id=5ca81ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca81ffa",
  null
  
)

export default component.exports